<template>
	<div class="drawer">
		<el-drawer size="650px" :visible.sync="drawerStatus" @close='close' :title="'门店资产'" :wrapperClosable="false"  >
			<el-form :inline="true" class="form">
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="分类:" :label-width="formLabelWidth" >
							{{detail.type&&detail.type.name}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="编号:" :label-width="formLabelWidth" >
							{{detail.code}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="名称:" :label-width="formLabelWidth" >
							{{detail.name}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="规格:" :label-width="formLabelWidth" >
							{{detail.skuName}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="图片:" :label-width="formLabelWidth">
							<div class="imgView">
								<div v-for="(item,index) in detail.images" :key="index" class="imgItem">
									<el-image :src="item" :preview-src-list="[item]"></el-image>
								</div>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="描述:" :label-width="formLabelWidth">
							{{detail.remarks}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="包装清单:" :label-width="formLabelWidth">
							<div v-for="(item,index) in detail.packingList" :key="index" style="padding-top:10px;">
								<span style="padding-right: 10px;">名称{{index+1}}:</span>
								<span>{{item}}</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="close">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth:'80px',
				
				detail:{},
			}
		},
		computed:{
			
		},
		props:{
			id:{
				default:''
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
			if(this.id.length===32){
				this.$http.get(process.env.VUE_APP_zichan+'/api/AssetsInfo/detail', {
					id:this.id
				}).then(res => {
					if (res.code == 0) {
						this.detail = res.data
					}
				})
			}else{
				this.$http.get(process.env.VUE_APP_zichan+'/api/AssetsInfo/detailbycode', {
					code:Number(this.id)
				}).then(res => {
					if (res.code == 0) {
						this.detail = res.data
					}
				})
			}
			
		},
		methods: {
			close(){
				this.$emit('submit',{type:'close'})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.el-drawer__body{
				overflow: auto;
			}
			.form{
				::v-deep .el-form-item{
					margin:5px 0;
					
				}
				
			}
		}
		
	}
	.imgView{
		flex: 1;
		.imgItem{
			position: relative;
			width: 80px; 
			height: 80px;
			margin-right:20px;
			margin-bottom: 10px;
			float: left;
			img{
				width: 100%;
				height: 100%;
			}
			.closeBtn{
				display: block;
				color: red;
				position: absolute;
				top: -10px;
				right: -10px;
				font-size: 20px;
				z-index: 5;
			}
		}
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
</style>
